import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import {
  Box,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import { enGB } from "date-fns/locale";
import { Link, useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/loading-indicator";
import TableHeader from "../../components/table-header";
import useBEDatatable from "../../hooks/use-be-datatable";
import { AppContent, ContentRow } from "../../styled/components";
import { getContacts } from "./api-service";
import { formatContactName } from "./format-contact-name";

function Contacts() {
  const navigate = useNavigate();

  const {
    ready,
    instancesList,
    filter,
    numberOfPages,
    pages,
    page,
    rangeEnd,
    rangeStart,

    // Functions
    setPage,
    filterChange,
  } = useBEDatatable({
    loadInstancesServiceAction: getContacts,
  });

  return (
    <>
      {!ready && <LoadingIndicator />}
      <AppContent>
        <TableHeader
          title="Contacts"
          showAddButton
          handleAddButtonClicked={() => navigate("/contacts/new")}
          filter={filter}
          filterChange={filterChange}
          firstItemIndex={rangeStart}
          lastItemIndex={rangeEnd}
          totalItems={instancesList.length}
        />
        <ContentRow>
          {ready && (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell
                      sx={{ display: { xs: "none", sm: "table-cell" } }}
                    >
                      Phone number
                    </TableCell>
                    <TableCell
                      sx={{ display: { xs: "none", md: "table-cell" } }}
                    >
                      Created At
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {instancesList.length > 0 &&
                    instancesList.map((_instance) => {
                      const displayName = formatContactName(_instance);
                      const TypeIcon = _instance["isCompany"]
                        ? BusinessIcon
                        : PersonIcon;
                      const iconLabel = _instance["isCompany"]
                        ? "Company contact"
                        : "Individual contact";
                      return (
                        <TableRow
                          key={`contact-${_instance.id}`}
                          sx={{
                            td: { paddingTop: 1, paddingBottom: 1 },
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                columnGap: 1,
                              }}
                            >
                              <TypeIcon
                                fontSize="small"
                                aria-label={iconLabel}
                                titleAccess={iconLabel}
                                color="action"
                              />
                              <Link to={`/contacts/${_instance.id}`}>
                                {displayName}
                              </Link>
                            </Box>
                          </TableCell>
                          <TableCell>{_instance["email"]}</TableCell>
                          <TableCell
                            sx={{ display: { xs: "none", sm: "table-cell" } }}
                          >
                            {_instance["phoneNumber"]}
                          </TableCell>
                          <TableCell
                            sx={{ display: { xs: "none", md: "table-cell" } }}
                          >
                            {_instance["createdAt"]
                              ? format(
                                  new Date(_instance["createdAt"]),
                                  "dd/MM/yyyy HH:mm",
                                  { locale: enGB },
                                )
                              : ""}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {instancesList.length === 0 && (
                    <TableRow
                      sx={{
                        td: { paddingTop: 1, paddingBottom: 1 },
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="center" colSpan={4}>
                        <Typography>
                          There are no Contacts yet. Add the first one by
                          clicking the "Add new" button
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </ContentRow>
        {numberOfPages > 1 && (
          <ContentRow
            style={{ display: "flex", justifyContent: "center", columnGap: 16 }}
          >
            <Pagination
              count={numberOfPages}
              page={page}
              variant="text"
              shape="rounded"
              color="primary"
              showFirstButton
              showLastButton
              onChange={(ev, page) => setPage(page)}
            />
          </ContentRow>
        )}
      </AppContent>
    </>
  );
}

export default Contacts;
